var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.show,
          expression: "show",
        },
      ],
      staticClass: "search-overlay",
      style: _vm.style,
    },
    [
      _c("search-option-input-text", {
        ref: "SearchInput",
        attrs: {
          "on-enter": _vm.onEnter,
          autofocus: true,
          placeholder: _vm.$t("common.search"),
        },
        model: {
          value: _vm.value,
          callback: function ($$v) {
            _vm.value = $$v
          },
          expression: "value",
        },
      }),
      _c("icon-close", {
        attrs: { title: _vm.$t("common.close") },
        on: { click: _vm.onClose },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }